// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"78ff6598","285":"d934bee6","317":"12409de7","918":"36f93581","985":"533ae6f1"}[chunkId] + ".chunk.js";
};